
import {Component, Input, OnInit, QueryList, ViewChildren} from "@angular/core";
import {UI_TEXTS} from "../../enums/e-texts";
import {ITalk} from "../../services/factory-service-impl/story.utils";
import {JP} from "../../helpers/jp";
import {FactoryService} from "../../services/factory.service";
import {CHAR_EMOTIONS_LIST, SCENE_CHARACTERS_LIST} from "../../enums/e-scene-types";
import {isUndefined} from "util";
import {IDocument} from "../../interfaces/document.definition";
import {paramsHelper} from "../../helpers/params-helper";
import {E_ENDPOINTS} from "../../helpers/params/loader-params";
import {DOCUMENT_TYPES} from "../../enums/enums";
import {NvSelect2Component} from "../nv-select/nv-select2.component";
import {GO_CATEGORIES} from "../../enums/e-game-objects";
import {CollectionService} from "../../services/collection.service";
import {localeUtils} from "../../helpers/locale-utils";

@Component({
  selector:"nv-talks",
  templateUrl:"./nv-talks.component.html"
})
export class NvTalksComponent implements OnInit{
  @ViewChildren(NvSelect2Component) selects: QueryList<NvSelect2Component>;

  UI_TEXTS = UI_TEXTS;
  SCENE_CHARACTERS_LIST = SCENE_CHARACTERS_LIST;
  CHAR_EMOTIONS_LIST = CHAR_EMOTIONS_LIST;
  loadedTalkingHeads:IDocument[] = [];

  private _document:any;
  private _pointer:string;
  private _selected:ITalk;

  @Input() set document(value: any) { this._document = value; }
  @Input() set pointer(value: string) { this._pointer = value; }

  get selected(): ITalk { return this._selected; }
  get document(): any { return this._document; }
  get pointer(): string { return this._pointer; }
  get talks():ITalk[] {
    return JP.get(this.document, this._pointer);
  }

  constructor(private factoryService: FactoryService,
              private collectionService: CollectionService) { }

  getLabel(talk:ITalk)
  {
    return localeUtils.findValue("speech", talk);
  }

  getContext()
  {
    return this;
  }

  ngOnInit():void{
    this.loadTalkingHeads();
  }

  onItemSelected(talk:ITalk){
    this._selected = talk;
  }

  onAddClick(){
    this.factoryService.addTalkTo(this.document,this.pointer);
  }

  getTalkingHeadLabel(talkingHead:IDocument):string
  {
    if (talkingHead.id >= 0)
    {
      return localeUtils.findValue("name", talkingHead);
    }
    else
    {
      return "NONE";
    }
    //return talkingHead["locales"][0]["value"][0];
  }

  loadTalkingHeads()
  {
   // console.log(`load th`);
    const search = paramsHelper
      .search()
      .addStringParam("category", GO_CATEGORIES.TALKING_HEAD)
      .json;

    const params = paramsHelper
      .loader()
      .setEndpointApi()
      .setObjectType(DOCUMENT_TYPES.GO)
      .setNavParams(0, 9999)
      .setSearchParams(search);

    this.collectionService.loadChunkCached(params)
      .subscribe(
        r => {
          this.loadedTalkingHeads = r.documents.concat([{_id:"", id: -1}]);
         // console.log(`th loaded ${JSON.stringify(this.loadedTalkingHeads)}`);
          //this.updateTalkingHeadsSelects();
        });
  }

  private updateTalkingHeadsSelects() {
    if (!this.selects) {
      return;
    }
    console.log(this.selects);

    this.selects
      .forEach((select: NvSelect2Component): void => select.setItems(this.loadedTalkingHeads));
  }

}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/nv-scenes/nv-talks.component.ts